'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalTransitionContextProvider = exports.ModalTransitionContextConsumer = exports.ModalTransitionContext = exports.defaultModalTransitionContext = undefined;

var _react = require('react');

var defaultModalTransitionContext = exports.defaultModalTransitionContext = {
  transitioning: false
};

var ModalTransitionContext = exports.ModalTransitionContext = (0, _react.createContext)(defaultModalTransitionContext);

var ModalTransitionContextConsumer = ModalTransitionContext.Consumer,
    ModalTransitionContextProvider = ModalTransitionContext.Provider;
exports.ModalTransitionContextConsumer = ModalTransitionContextConsumer;
exports.ModalTransitionContextProvider = ModalTransitionContextProvider;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/context/ModalTransitionContext.js
// module id = 195
// module chunks = 3 4 5